import React from 'react';
import './RulesIntro.scss';
import Divider from './Divider';
import cx from 'classnames';
import { SYLLABLE_TYPES } from './helpers';
import football from './assets/football.svg';
import lion from './assets/lion.svg';
import magic from './assets/magic.svg';
import magnet from './assets/magnet.svg';
import reptile from './assets/reptile.svg';
import robot from './assets/robot.svg';
import tiger from './assets/tiger.svg';
import toucan from './assets/toucan.svg';
import turtle from './assets/turtle.svg';

export default function RulesIntro({ headline, word, type }) {
  const getClassType = () => {
    switch (type) {
      case SYLLABLE_TYPES.VCe:
        return 'vce';
      case SYLLABLE_TYPES.VT:
        return 'vt';
      case SYLLABLE_TYPES.rControlled:
        return 'r-controlled';
      case SYLLABLE_TYPES.VCCV:
        return 'vccv';
      case SYLLABLE_TYPES.compound:
        return 'compound';
      case SYLLABLE_TYPES.CLe:
        return 'c-le';
      case SYLLABLE_TYPES.VV:
        return 'vv';
      case SYLLABLE_TYPES.vCV:
      case SYLLABLE_TYPES.VCv:
        return 'vcv';
      default:
        return '';
    }
  };

  const getImage = () => {
    let src = null;
    let alt = '';
    switch (type) {
      case SYLLABLE_TYPES.VCe:
        src = reptile;
        alt = 'Reptile';
        break;
      case SYLLABLE_TYPES.VT:
        src = toucan;
        alt = 'Toucan';
        break;
      case SYLLABLE_TYPES.rControlled:
        src = tiger;
        alt = 'Tiger';
        break;
      case SYLLABLE_TYPES.VCCV:
        src = magnet;
        alt = 'Magnet';
        break;
      case SYLLABLE_TYPES.compound:
        src = football;
        alt = 'Football';
        break;
      case SYLLABLE_TYPES.CLe:
        src = turtle;
        alt = 'Turtle';
        break;
      case SYLLABLE_TYPES.VV:
        src = lion;
        alt = 'Lion';
        break;
      case SYLLABLE_TYPES.vCV:
        src = robot;
        alt = 'Robot';
        break;
      case SYLLABLE_TYPES.VCv:
        src = magic;
        alt = 'Magic';
        break;
    }

    return <img alt={alt} src={src} />;
  };

  return (
    <div className={`rabbit-rule-container ${getClassType()}`}>
      <div className="rabbit-rule">
        <h2>{headline}</h2>
        <div className="image-container">{getImage()}</div>
        <div className="word">
          {word.map((l) => (
            <>
              {l.content === '/' ? (
                <Divider key={l.id} visible dividerClasses="letter" />
              ) : (
                <div
                  key={l.id}
                  className={cx({ letter: true, [l.rule]: true })}
                >
                  {l.content}
                </div>
              )}
            </>
          ))}
        </div>
      </div>
    </div>
  );
}
